var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _vm._v("\n\t" + _vm._s(_vm.prefix) + "\n\t"),
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy.number",
                value: _vm.rawValue,
                expression: "rawValue",
                modifiers: { lazy: true, number: true }
              }
            ],
            staticClass: "appearance-textfield hide-steppers",
            attrs: { type: "number", required: "" },
            domProps: { value: _vm.rawValue },
            on: {
              change: function($event) {
                _vm.rawValue = _vm._n($event.target.value)
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v("\n\t" + _vm._s(_vm.suffix) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }